import { Group } from "../types/groupsAndRolesTypes";

export const groupInitialValues: Group = {
  id: "",
  name: "",
  description: "",
  parentGroup: { id: "", name: "" },
};
